import React from 'react';
import css from './InsurancePlusSign.css';

const InsurancePlusSign = (props) => {
  return (<span className={css.root}><sup>+</sup></span>);
};

export default InsurancePlusSign;
